import React, { createContext, useContext, ReactNode } from 'react';

interface SnackbarContextType {
    showSnackbar: (message: string) => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const useSnackbar = (): SnackbarContextType => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};

interface SnackbarProviderProps {
    children: ReactNode;
    onShowSnackbar: (message: string) => void;
}

export const SnackbarProvider: React.FC<SnackbarProviderProps> = ({ children, onShowSnackbar }) => {
    const showSnackbar = (message: string): void => {
        onShowSnackbar(message);
    };

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}
        </SnackbarContext.Provider>
    );
};
